<template>
  <div id="onboarding-complete" class="fade-in" :class='{ mobile: isMobile() }' >
    <div class="onboarding-complete-content">
      <StepInfoHeader :showHeaderHelperIcon="false" />
       <template>
        <h2>
          Você será avisado por email e SMS quando a análise da {{
            bypassDocuments ? 'selfie' : 'documentação'
          }} for concluída.
        </h2>

        <div class="step-list">
          <div class="step-list-item finish">
            <div class="step-list-icon">
              <IdentificationIcon size="32" color="var(--blue-400)" />
            </div>
            <div class="step-list-text">
              {{ bypassDocuments ? 'Selfie' : 'Documentação' }} em análise<br/>
              <span v-if="sendDocumentAt">
                Enviada em {{ sendDocumentAt | dateFilter }}
              </span>
            </div>
          </div>

          <div class="step-list-item pending" v-if="downPayment && !downPaymentPaid">
            <div class="step-list-icon">
              <CurrencyDollarIcon size="32" color="var(--gray-400)" />
            </div>
            <div class="step-list-text">
              Pagamento da entrada<br/>
              <span v-if="bypassDocuments">Aguarde a aprovação da selfie</span>
              <span v-else>Aguarde a confirmação da documentação enviada</span>
            </div>
          </div>
        </div>

        <div class="footer">
          <Button class="footer-btn" @click="() => $router.push('/portal')">
            <span>Acessar o Parcelex</span>
          </Button>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { IdentificationIcon, CurrencyDollarIcon } from '@vue-hero-icons/outline';

import Button from '@/components/ui/AppButton.vue';
import UtilMixing from '@/mixins/util';
import StringMixin from '@/mixins/string';

import StepInfoHeader from '../components/StepInfoHeader.vue';

export default {
  name: 'onboarding-complete',
  components: {
    StepInfoHeader,
    Button,
    IdentificationIcon,
    CurrencyDollarIcon,
  },
  mixins: [UtilMixing, StringMixin],
  computed: {
    ...mapState('onboarding', [
      'step',
      'downPaymentLink',
      'downPayment',
      'downPaymentPaid',
      'downPaymentDueDate',
      'sendDocumentAt',
      'bypassDocuments',
    ]),
    ...mapState('auth', [
      'token',
    ]),
  },
  methods: {
    goToBillet() {
      window.location.href = this.downPaymentLink;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../styles/index.scss';

  #onboarding-complete {
    padding-top: 20px;
    background-color: var(--gray-100);
    box-sizing: inherit;
    position: relative;
    min-height: 100vh;
    max-width: 100%;
    margin: 0 auto;
    height: 100vh;

    .onboarding-complete-content {
      padding: 0 24px;
      min-width: $sm;
      max-width: 642px;
      min-height: 304px;
      background-color: var(--white);
      border-radius: 4px;
      border: 1px solid var(--gray-300);
      box-sizing: border-box;
      margin: 0 auto;

      .footer {
        margin-bottom: 20px;
        margin-top: 150px;
        text-align: center;

        .footer-btn {
          @extend .primary;

          width: 224px;
          height: 38px;
        }
      }
    }

    h2 {
      margin-top: 20px;

      color: var(--blue-400);
      font-weight: 600;
      font-size: 20px;
      line-height: 28px;
    }

    &.mobile {
      padding: 0px;
      background-color: var(--white);

      .onboarding-complete-content {
        margin: 0 auto;
        min-width: 100%;
        border: 0px;

        h2 {
          margin-top: 20px;

          color: var(--blue-400);
          font-weight: 600;
          font-size: 20px;
          line-height: 28px;
        }

        .footer {
          margin: 0;
          bottom: 0;
          left: 0;
          box-sizing: border-box;
          position: fixed;
          width: 100%;
          height: 88px;
          padding: 20px 24px;

          span {
            padding-left: 8px;
          }

          .footer-btn {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }

  .last-buttom {
    padding: 20px 0;
  }

  .title {
    margin-top: 24px;

    h2 {
      color: var(--gray-600);
      display: inline;
    }

    img {
      position: absolute;
      width: 20px;
      margin: 7px 0 0 5px;
    }
  }

  .dp-text {
    p {
      @extend .lead;
      margin: 16px 0px;
      line-height: 26px;
    }

    p:nth-child(2n) {
      @extend .lead-semibold;
      line-height: 26px;
    }
  }

  .dp-content {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .bottom-line {
    flex-grow: 3;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    width: 100%;
    .bottom-btn {
      width: 100%;
      height: 48px;
      margin-bottom: 12px;
    }
  }
</style>
